import { IBaseSearchAutocomplete, BaseSearchAutocomplete } from "Services/API/API";

interface IFullTextSearchAutocomplete extends IBaseSearchAutocomplete {
   fullTextQuery: string;
}

export class FullTextSearchAutocomplete extends BaseSearchAutocomplete implements IFullTextSearchAutocomplete {
   /** Full text query */
   fullTextQuery: string;

   constructor(fullTextQuery: string) {
      super();
      this.fullTextQuery = fullTextQuery;
      this._discriminator = "FullTextSearchAutocomplete";
   }
}